import IDMInvitationClient from './client';
export default IDMInvitationClient;
//# sourceMappingURL=index.js.map